<template>
  <v-dialog
    :max-width="maxWidth"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Nuevo Diagnóstico</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="7" md="4">
              <v-select
                :items="profsBuscar"
                item-text="nombreProfesional"
                item-value="idProfesional"
                menu-props="auto"
                label="Profesional *"
                hide-details
                prepend-icon="mdi-account"
                v-model="prof"
                dense
                no-data-text="No hay Profesionales configurados"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="7" md="4">
              <v-text-field
                v-model="fecha"
                :value="fecha"
                label="Fecha *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                :items="patologias"
                v-model="patologia"
                item-text="nombrePatologia"
                item-value="idPatologia"
                label="Patología *"
                :rules="requiredRules"
                dense
                prepend-icon="mdi-heart-pulse"
                return-object
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-textarea
                prepend-icon="mdi-hospital"
                v-model="observaciones"
                label="Observaciones"
                clearable
                auto-grow
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="guardarDiagnostico"
            >Guardar</v-btn
          >
          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.v-dialog__content {
  align-items: left;
  justify-content: left;
}
</style>
<script>
import axios from "../../axios-auth.js";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],

    prof: "",
    profsBuscar: [],
    fecha: null,
    patologia: null,
    patologias: [],
    observaciones: "",
    maxWidth: "100%",
  }),
  props: ["visible", "idPaciente"],
  computed: {
    show: {
      get() {
        if (this.visible) this.setearModels();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    buscarPatologias() {
      let self = this;
      const institucion = this.$store.state.usuario.institucion;
      // Fuente única de patologías (las 3 son excluyentes, nunca se combinan):
      // 1) por institución  2) por empresa  3) general.
      if (institucion.usaPatologiasInstitucion) {
        axios
          .get("/Turnos/GetPatologiasInstitucion", {
            params: {
              idInstitucion: institucion.idInstitucion,
            },
          })
          .then((response) => {
            self.patologias = response.data;
          })
          .catch((error) => {});
      } else if (institucion.esEmpresa) {
        axios
          .get("/Turnos/GetPatologiasEmpresas", {
            params: {
              idInstitucion: institucion.idInstitucion,
              idProfesional: self.prof,
            },
          })
          .then((response) => {
            self.patologias = response.data;
          })
          .catch((error) => {});
      } else {
        axios
          .get("/Turnos/GetPatologias")
          .then((response) => {
            self.patologias = response.data;
          })
          .catch((error) => {});
      }
    },
    guardarDiagnostico() {
      this.$swal({
        title: "Registrar Diagnostico",
        text: "¿Desea registrar el diagnóstico?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (this.patologia.idPatologia === undefined) {
          this.showAlert({
            icon: "error",
            title: "Por favor elija un diagnóstico válido de la lista.",
            vm: this,
          });
          this.patologia = null;
          return;
        }
        if (result.value) {
          const datosDiagnostico = {
            fecha: this.fecha,
            idPaciente: this.idPaciente,
            idProfesional: this.prof,
            idPatologia: this.patologia.idPatologia,
            observaciones: this.observaciones,
            esEmpresa: this.$store.state.usuario.institucion.esEmpresa,
          };
          let self = this;
          axios
            .post("/HistoriaClinica/GuardarDiagnostico", datosDiagnostico)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active"
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Diagnóstico registrado exitosamente",
                vm: self,
              });
              self.$emit("diagnosticoRegistrado");
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El diagnóstico no pudo ser registrado",
                vm: this,
              });
            });
        }
      });
    },

    setearModels() {
      const profData = {
        usuario: this.$store.state.usuario.usuario,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Turnos/BuscarProfesionalesAsociados?", {
          params: {
            usuario: profData.usuario,
            idInstitucion: profData.idInstitucion,
          },
        })
        .then((response) => {
          self.profsBuscar = response.data.profesionales;
          self.prof =
            self.$store.state.indexProf || self.profsBuscar[0].idProfesional;

          self.buscarPatologias();
        });

      this.fecha = this.parseDate(this.formatDate(this.toISOLocal(new Date())));
      if (this.$store.state.videollamada == true) this.maxWidth = "68%";
      else this.maxWidth = "100%";
    },

    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    vaciarModels() {
      this.observaciones = "";
      this.patologia = null;
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
